import noPictureProfil from '../assets/noPictureProfil.png';
import isDarkColor from 'is-dark-color';

import TimeAgo from 'javascript-time-ago';
import moment from 'moment';

// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en';

// Add locale-specific relative date/time formatting rules.
TimeAgo.addLocale(en);

export default {
  data() {
    return {
      projectId: "5f9934dea25c715d7f9a663c",
      skillId: null,
      timeAgo: null,
      noPictureProfil,
      themeColors: {
        primary: '#3796F3',
        secondary: '#53C29C',
        // accent: '#82b1ff',
        error: '#E74C3D',
        info: '#3796F3',
        success: '#69CB85',
        warning: '#F9C009'
      }
    };
  },
  methods: {
    isDarkColor,
    formatDate(strDate) {
      return this.timeAgo.format(moment(strDate).toDate());
    },
    logout() {
      this.token = null;
      this.role = null;
      this.picture = null;
      this.currentUserName = null;
      this.$router.push({ path: 'home' });
    }
  },
  computed: {
    lang: {
      get() {
        return this.$storage.get('lang') || 'en';
      },
      set(value) {
        return this.$storage.set('lang', value);
      }
    },
    token: {
      get() {
        return this.$store.state.token;
      },
      set(value) {
        this.$storage.set('token', value);
        return this.$store.commit('setToken', value);
      }
    },
    isLoggedIn: {
      get() {
        return !!this.$store.state.token;
      }
    },
    role: {
      get() {
        return this.$store.state.role;
      },
      set(value) {
        this.$storage.set('role', value);
        return this.$store.commit('setRole', value);
      }
    },
    picture: {
      get() {
        return this.$store.state.picture;
      },
      set(value) {
        this.$storage.set('picture', value);
        return this.$store.commit('setPicture', value);
      }
    },
    currentUserName: {
      get() {
        return this.$store.state.currentUserName;
      },
      set(value) {
        this.$storage.set('currentUserName', value);
        return this.$store.commit('setCurrentUserName', value);
      }
    },
    breadcrumbs: {
      get() {
        return this.$store.state.breadcrumbs;
      },
      set(value) {
        this.$storage.set('breadcrumbs', value);
        return this.$store.commit('setBreadcrumbs', value);
      }
    },
    colors: {
      get() {
        return this.$store.state.colors;
      },
      set(value) {
        this.$storage.set('colors', value);
        return this.$store.commit('setColors', value);
      }
    },
    currentProject: {
      get() {
        return this.$store.state.currentProject;
      },
      set(value) {
        return this.$store.commit('setCurrentProject', value);
      }
    },
    currentLinks: {
      get() {
        return this.$store.state.links;
      },
      set(value) {
        return this.$store.commit('setCurrentLinks', value);
      }
    }
  },
  beforeMount() {
    this.timeAgo = new TimeAgo(this.lang);
  }
};
